import { useQuery } from '@tanstack/react-query';
import { getRealmUserInfo } from '../../services/keycloak';

export const useUserInfoQuery = (doctorId?: string, token?: string) => {
  return useQuery({
    queryKey: ['doctor-user-info', doctorId],
    queryFn: () => {
      if (!doctorId || !token) {
        throw new Error('Missing parameters');
      }
      return getRealmUserInfo(doctorId, token);
    },
    enabled: Boolean(doctorId && token),
    staleTime: 5 * 60 * 1000
  });
};
